import dayjs from "dayjs";
import { TogglesClass } from "./Toggles";

interface TimestampProps {
  Timestamp: Date;
  Toggles: TogglesClass;
}

export default function Timestamp(props: TimestampProps) {
  if (props.Timestamp === undefined) {
    return <span className="Timestamp Empty">-</span>;
  } else {
    var schmeeb: Date = props.Timestamp as Date;
    var schmeeby = dayjs(schmeeb);
    var longstring = props.Timestamp.toString();
    if (props.Toggles.ShowMilliseconds === true) {
      var squishystring = schmeeby.format("YYYY-MM-DD HH:mm:ss.SSS");
      return (
        <span className="Timestamp" title={longstring}>
          {squishystring}
        </span>
      );
    } else {
      var schmeebstring = schmeeby.format("YYYY-MM-DD HH:mm:ss");
      return (
        <span className="SquishedTimestamp" title={longstring}>
          {schmeebstring}
        </span>
      );
    }
  }
}
